import { TipoUnidadeSaudeEnum } from 'graphql/types.generated'

export const grupoTiposUnidadeSaudeEspecializadoCC = [
  TipoUnidadeSaudeEnum.POLICLINICA,
  TipoUnidadeSaudeEnum.HOSPITAL_GERAL,
  TipoUnidadeSaudeEnum.CLINICA_CENTRO_DE_ESPECIALIDADE,
  TipoUnidadeSaudeEnum.UNIDADE_DE_APOIO_DIAGNOSE_E_TERAPIA_SADT_ISOLADO,
  TipoUnidadeSaudeEnum.FARMACIA,
  TipoUnidadeSaudeEnum.CENTRO_DE_PARTO_NORMAL_ISOLADO,
  TipoUnidadeSaudeEnum.HOSPITAL_DIA_ISOLADO,
  TipoUnidadeSaudeEnum.CENTRAL_DE_REGULACAO_DE_SERVICOS_DE_SAUDE,
  TipoUnidadeSaudeEnum.CENTRAL_DE_GESTAO_EM_SAUDE,
  TipoUnidadeSaudeEnum.CENTRO_DE_ATENCAO_PSICOSSOCIAL,
  TipoUnidadeSaudeEnum.PRONTO_ATENDIMENTO,
  TipoUnidadeSaudeEnum.TELESSAUDE,
  TipoUnidadeSaudeEnum.CENTRAL_DE_REGULACAO_MEDICA_DAS_URGENCIAS,
  TipoUnidadeSaudeEnum.UNIDADE_DE_ATENCAO_EM_REGIME_RESIDENCIAL,
  TipoUnidadeSaudeEnum.CENTRAL_DE_REGULACAO_DO_ACESSO,
  TipoUnidadeSaudeEnum.CENTRO_DE_IMUNIZACAO,
]
